let apiUrl = "https://api-master.sunbit.dev";
if (typeof sunbitE2eEnvNamespace !== "undefined") { // eslint-disable-line no-undef
  apiUrl = `https://admin-api-${sunbitE2eEnvNamespace}.e2e.sunbit.dev` // eslint-disable-line no-undef
}
const config = {
  apiUrl,
  apiUrlPci: null,
  sampling: {
    "endpoint": "http://localhost:4101/api/v1/sampling",
    "disabled": true
  },
  launchDarklyClientId: '64dc7b38c6c3611347d56cda',
};
export default config;



// WEBPACK FOOTER //
// ./src/config/remote-dev.js